<div [attr.data-cy]="'grid-cell-id-'+columnDef.id">
  <ng-container *ngTemplateOutlet="columnDef.displayControlDef.template; context: {$implicit: row}">
  </ng-container>
</div>